/*
 * File: index.tsx
 * Desc: 编辑表格选择框渲染
 * File Created: 2019-12-05 17:24:16
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useEffect } from 'react';
import { Select } from 'antd';

interface TdSelectRenderProps {
    style?: React.CSSProperties;
    className?: string;
    value?: any;
    onChange?: (value: any) => void;
    validator?: (value: any) => boolean;
    options?: any[];
}

/** 编辑表格选择框渲染 */
const TdSelectRender = (props: TdSelectRenderProps) => {
    const { validator } = props;
    const [value, setValue] = useState(props.value);

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    function onSearch(inputValue: any) {
        handleValue(inputValue);
    }

    function onChange(value: string) {
        handleValue(value);
    }

    function handleValue(value: string) {
        if (validator && !validator(value)) {
            return;
        }
        setValue(value);
        props.onChange && props.onChange(value);
    }

    return (
        <Select
            className={props.className}
            value={value}
            style={{ minWidth: 100, ...props.style }}
            onChange={onChange}
            onSearch={onSearch}
            allowClear
        >
            {props.options &&
                props.options.map(option => (
                    <Select.Option key={option.key}>{option.value}</Select.Option>
                ))}
        </Select>
    );
};

export default TdSelectRender;
